import { OptionWrapper } from './OptionWrapper'
import { COLOR_PRIMARY } from '../../constants'

type Nprs11pt2lProps = {
  question: any
  answerIndex: number
  defaultLang: string
  variant?: 'PRIMARY' | 'SECONDARY'
}

export const Nprs11pt2l = ({ question, answerIndex, defaultLang, variant = 'PRIMARY' }: Nprs11pt2lProps) => {
  const variantStyles = {
    primary: {
      body: 'd-flex w-100 justify-md-content-between justify-content-start gap-2',
      optionClass: 'border-1 border rounded-1 w-100 py-2',
      color: COLOR_PRIMARY,
    },
    secondary: { body: 'd-flex ', optionClass: 'border-1 border rounded-1 me-1 px-1 py-1 mb-2', color: '#b5b5b5' },
  }
  const currentVariant = variant === 'PRIMARY' ? variantStyles.primary : variantStyles.secondary

  return (
    <div className={currentVariant.body} style={{ maxWidth: 500 }}>
      {question?.options.intensity.map((option, questionIndex) => {
        return (
          <OptionWrapper
            key={`${answerIndex}-${questionIndex}`}
            className={currentVariant.optionClass}
            isSelected={answerIndex === questionIndex}
            body={option[defaultLang]}
            selectedColor={currentVariant.color}
          />
        )
      })}
    </div>
  )
}
